import { ButtonSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { useSettingsForm } from '../../content-composer/hooks/use-settings-form';
import { AlignmentSetting } from '../../content-composer/settings-atoms/alignment-setting';
import { ButtonSetting } from '../../content-composer/settings-atoms/button-setting';
import { FrameSetting } from '../../content-composer/settings-atoms/frame-setting';
import { PaddingSetting } from '../../content-composer/settings-atoms/padding-setting';
import { SettingsPanel } from '../../content-composer/settings-panel/settings-panel';

export const ButtonSettings = () => {
  const { t } = useTranslation('content-composer');

  const { getFieldProps } = useSettingsForm<ButtonSection>({
    buttonColor: { type: 'text' },
    corners: { type: 'radio' },
    frame: {
      alignment: { type: 'radio' },
      backgroundColor: { type: 'text' },
      paddingTop: { type: 'text' },
      paddingBottom: { type: 'text' },
      paddingLeft: { type: 'text' },
      paddingRight: { type: 'text' },
    },
    textColor: { type: 'text' },
  });

  return (
    <SettingsPanel>
      <SettingsPanel.Header>{t('Button')}</SettingsPanel.Header>
      <SettingsPanel.Body>
        <AlignmentSetting {...getFieldProps('frame', 'alignment')} />
        <ButtonSetting
          backgroundColorFieldProps={getFieldProps('buttonColor')}
          cornersFieldProps={getFieldProps('corners')}
          textColorFieldProps={getFieldProps('textColor')}
        />
        <FrameSetting {...getFieldProps('frame', 'backgroundColor')} />
        <PaddingSetting
          paddingTopFieldProps={getFieldProps('frame', 'paddingTop')}
          paddingBottomFieldProps={getFieldProps('frame', 'paddingBottom')}
          paddingLeftFieldProps={getFieldProps('frame', 'paddingLeft')}
          paddingRightFieldProps={getFieldProps('frame', 'paddingRight')}
        />
      </SettingsPanel.Body>
    </SettingsPanel>
  );
};
